import { useEffect } from "react";

function setTag(selector, content) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    const m = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (!m) return;
    tag.setAttribute(m[1], m[2]);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setTag('meta[name="description"]', description);
      setTag('meta[property="og:title"]', title);
      setTag('meta[property="og:description"]', description);
      setTag('meta[name="twitter:title"]', title);
      setTag('meta[name="twitter:description"]', description);
    }
  }, [title, description]);
}
